import axios from "axios";
import { ENV } from "@/env";

export const axiosClient = axios.create({
  baseURL: ENV.API_BASE_URL,
});
